export default {_name:'card.simple',module:'Field',view:'Element/Card',webOptions:{sm:6,xs:12,ms:12},mobileOptions:{ms:6}}